import React from 'react';
import Card from 'react-bootstrap/Card';
import PropTypes from 'prop-types';

const BlogPostCard = ({ content }) => {
    return (
        <Card className="text-center">
            <Card.Body>
                {content}
            </Card.Body>
            <Card.Footer />
        </Card>
    );
};

BlogPostCard.propTypes = {
    content: PropTypes.node.isRequired,
};

export default BlogPostCard;
